import * as React from 'react';
import { styled } from './druid/./druid/Utilities';
import { DropdownBase } from '/druid/Dropdown.base';
import { getStyles } from '/druid/Dropdown.styles';
import { IDropdownProps, IDropdownStyleProps, IDropdownStyles } from '/druid/Dropdown.types';

export const Dropdown: React.FunctionComponent<IDropdownProps> = styled<
  IDropdownProps,
  IDropdownStyleProps,
  IDropdownStyles
>(DropdownBase, getStyles, undefined, {
  scope: 'Dropdown',
});
